module.exports = __webpack_public_path__ + "img/shot-b.bd52456b.svg";